const Countdown = () => {
  const now = new Date();
  const countDate = new Date("May 17 2026 23:59:59 GMT-0400").getTime();
  const gap = countDate - now;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const textDay = Math.floor(gap / day);
  const textHour = Math.floor((gap % day) / hour);
  const textMinute = Math.floor((gap % hour) / minute);
  const textSecond = Math.floor((gap % minute) / second);
  const textMillisecond = (gap % 1000) / 1000;
  const msString = String(Math.floor(textMillisecond * 100)).padStart(2, "0"); // Truncate to 2 digits

  const pad = (num, digits = 2) => String(num).padStart(digits, "0");

  if (gap >= 0){
    document.querySelector('.day').innerText = pad(textDay);
    document.querySelector('.hour').innerText = pad(textHour);
    document.querySelector('.minute').innerText = pad(textMinute);

    const dayContainer = document.querySelector('.container-day');
    const secondEl = document.querySelector('.second');
      // Add seconds + millisecond span
      secondEl.innerHTML = `${pad(textSecond)}<span class="ms">.${msString}</span>`;
  }
};

setInterval(Countdown, 25);

var progress = document.querySelector('.progress');

let progressBar = document.getElementById("progressBAR");

  // Update the count down every 1 second
  var x = setInterval(function() {
    
  var begin = new Date("May 08, 2026 00:00:00").getTime();
  var end = new Date("May 17, 2026 23:59:59").getTime();

  // Get today's date and time
  var now = new Date();
  var localTime = now.getTime();
  var localOffset = now.getTimezoneOffset() * 60000;
  
  var utc = localTime + localOffset;
  // var offset = -5;   
  var offset = -4;
  var newyork = utc + (3600000*offset);

  var nowNewYork = new Date(newyork); 
    
  // nowActual is relative to beginning date of giveaway
  var nowActual = nowNewYork.getTime() - begin;

  // Find the distance between now and the count down date
  var distance = end - nowNewYork;
    
  // FULL DURATION NARROWS TIME FROM END TO BEGINNING
  var fullDuration = end - begin;
  // GET FRACTION OF ACTUAL CURRENT TIME DIVIDED BY FULL DURATION
  var timeLeft = nowActual/fullDuration;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // USE TO CHECK Dates in Number Formats
  // console.log(end2);
  // console.log(fullDuration2);
  // console.log(timeLeft2);
    
  // If time is UP or NOT BEGUN set progress bar to full, else fill it appropriately!
  if (timeLeft >= 1){
      progress.style.width = (100 + '%');
      progress.style.opacity = 1;
  } else if (timeLeft <= 0) {
    progress.style.width = (100 + '%');
    progress.style.opacity = 1;
  } else { 
      if ((timeLeft*100) > 60){
        progressBar.style.display = 'block';
         progress.style.width = (60 + (timeLeft*40) + '%');
        progress.style.opacity = 1;
      }
  }
 
}, 1000);